import { render, staticRenderFns } from "./KnFormAssignSubjectTeacher.vue?vue&type=template&id=1c871533"
import script from "./KnFormAssignSubjectTeacher.js?vue&type=script&lang=js&external"
export * from "./KnFormAssignSubjectTeacher.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports